function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Input, Form, Button, Select, Alert, Radio, List, InputNumber, Modal, Typography, Descriptions, message, DatePicker } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import axios from 'axios';
import Common from "../includes/Common";
import { ExclamationCircleFill, Upload as UploadIc, PersonVcardFill, Building, TelephoneFill, CalendarEventFill, GeoAltFill } from 'react-bootstrap-icons';
import Receipt from "../Receipt";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Option = Select.Option;

var RegisterPatient = function RegisterPatient(_ref) {
  var handler = _ref.handler;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormLoading = _useState2[0],
      setIsFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      companyOptions = _useState8[0],
      setCompanyOptions = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      companies = _useState10[0],
      setCompanies = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      rdata = _useState12[0],
      setRdata = _useState12[1];

  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var genderOptions = [{
    label: 'H',
    value: 'H'
  }, {
    label: 'F',
    value: 'F'
  }];

  var onCompanyChanged = function onCompanyChanged(v) {};

  var onFinish = function onFinish(values) {
    setRdata([]);
    var formData = new FormData();
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append('job', values.job);
    formData.append('birthdate', values.birthdate);
    formData.append('company_id', values.company_id);
    formData.append('mobile', values.mobile);
    formData.append("address", values.address);
    formData.append('gender', values.gender);
    formData.append("user_id", Common.currentUser.id);
    setErrorMessage('');
    setSuccessMessage('');
    axios.post(Common.baseApiUrl + 'registerpatient/' + Common.currentUser.id.toString(), formData).then(function (response) {
      setIsFormLoading(false);

      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setErrorMessage('Une erreur est survenue');
    });
  };

  useEffect(function () {
    setCompanyOptions([{
      value: 0,
      label: 'Aucune'
    }]);
    axios.get(Common.baseApiUrl + "getcompanylist/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCompanies(response.data.companyList);
        response.data.companyList.forEach(function (c) {
          if (c.company_id == null) setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });else setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.company == null ? "" : c.company.label + "-" + c.label,
              value: c.id
            }]);
          });
        });
      }

      form.setFieldsValue({
        gender: 'F',
        category: 0,
        company_id: 0
      });
    })["catch"](function (error) {});
  }, []);
  return /*#__PURE__*/_jsx("div", {
    style: {
      padding: "11px",
      borderRadius: "7px",
      background: "#FED087"
    },
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: onFinish,
      form: form,
      children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          message: errorMessage,
          type: "error",
          showIcon: true
        })
      }), successMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          message: successMessage,
          type: "success",
          showIcon: true
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "firstname",
            label: "Pr\xE9nom",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(PersonVcardFill, {})
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "lastname",
            label: "Nom",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(PersonVcardFill, {})
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "job",
            label: "Profession",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(Building, {})
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile",
            label: "T\xE9l\xE9phone",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(TelephoneFill, {})
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "company_id",
        label: "Prise en charge",
        children: /*#__PURE__*/_jsx(Select, {
          onChange: onCompanyChanged,
          disabled: false,
          defaultActiveFirstOption: true,
          optionLabelProp: "label",
          optionFilterProp: "label",
          filterOption: function filterOption(input, option) {
            return option.label.toLowerCase().includes(input.toLowerCase());
          },
          showSearch: true,
          options: companyOptions
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "birthdate",
            label: "\xC2ge",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              min: 0,
              max: 200,
              addonAfter: "Ans"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "gender",
            label: "Genre",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Radio.Group, {
              options: genderOptions,
              optionType: "button",
              buttonStyle: "solid"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Adresse",
        name: "address",
        children: /*#__PURE__*/_jsx(Input, {
          prefix: /*#__PURE__*/_jsx(GeoAltFill, {})
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "submit",
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "Enregistrer"
          })
        })
      })]
    })
  });
};

export default RegisterPatient;